export const waitForElement = (
	selector: string,
	root: ParentNode & Node,
	signal?: AbortSignal
): Promise<Element | null> => {
	const existing = root.querySelector(selector)
	if (existing) return Promise.resolve(existing)
	if (signal?.aborted) return Promise.resolve(null)

	return new Promise((resolve) => {
		const observer = new MutationObserver(() => {
			const el = root.querySelector(selector)
			if (el) {
				observer.disconnect()
				resolve(el)
			}
		})
		signal?.addEventListener(
			'abort',
			() => {
				observer.disconnect()
				resolve(null)
			},
			{ once: true }
		)
		observer.observe(root, { childList: true, subtree: true })
	})
}
